<template>
  <div>
    <ModalAlert 
      :id="'modal-app-other-user-is-using'"
      :show="show" 
      :variant="'danger'"
      :title="'Another user is editing this website.'"
      :hideFooter="true"
      :noCloseOnEsc="true"
      :noCloseOnBackdrop="true"
    >
      <template #description>
        <div class="fs-sa-16">{{ errorData.email }} {{$t('engine.modal.singleEdit.lblLabel1',languageEngine)}}</div>
        <br/>
        <div class="fs-sa-12">{{$t('engine.modal.singleEdit.lblLabel2',languageEngine)}} {{ errorData.email }} {{$t('engine.modal.singleEdit.lblLabel3',languageEngine)}}</div>
        <br/>
        <div class="d-flex justify-content-end">
          <b-button variant="danger" @click="onContinue">{{$t('engine.modal.singleEdit.btnEdit',languageEngine)}}</b-button
        >
        <b-button variant="default" @click="onClose" class="mr-3">{{$t('engine.modal.singleEdit.btnClose',languageEngine)}}</b-button
        >
        </div>
      </template>
    </ModalAlert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalAlert from "@components_system/Shared/Tools/ModalAlert/ModalAlert";

export default {
  components: {
    ModalAlert,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      synceError: "design/snapshot/synceError",
      synceResponse: "design/snapshot/synceResponse",
      services: "design/page/services",
    }),
    show() {
      return this.synceError && (this.synceResponse.data.error == 'ERROR_DESIGN_OTHER_USER_IS_USING' || this.synceResponse.data.error == 'ERROR_DESIGN_JSON_NOT_UP_TO_DATE');
    },
    errorStatus() {
      return (this.synceError && this.synceResponse && this.synceResponse.status) || '';
    },
    errorMsg() {
      return (this.synceError && this.synceResponse && this.synceResponse.data.message) || '';
    },
    errorData() {
      return (this.synceError && this.synceResponse && this.synceResponse.data.data) || '';
    }
  },
  methods: {
    onContinue() {
      this.$store.dispatch("design/reload");
    },
    onClose() {
      window.open(this.services.mweDomain + "/" + this.languageEngine + '/account', '_self');
    }
  },
};
</script>